import { GilroyFontRegularUrls, GilroyFontMediumUrls, GilroyFontSemiBoldUrls, GilroyFontBoldUrls } from '../sources/index.js';

const GilroyFonts = [
    {
        fontFamily: 'Picsart-Fonts',
        fontStyle: 'normal',
        fontWeight: 'normal',
        src: {
            local: 'Gilroy-Regular',
            url: GilroyFontRegularUrls.normal.woff2,
            format: 'woff2',
        },
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: 'Picsart-Fonts',
        fontStyle: 'italic',
        fontWeight: 'normal',
        src: {
            local: 'Gilroy-RegularItalic',
            url: GilroyFontRegularUrls.italic.woff2,
            format: 'woff2',
        },
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: 'Picsart-Fonts',
        fontStyle: 'normal',
        fontWeight: '500',
        src: {
            local: 'Gilroy-Medium',
            url: GilroyFontMediumUrls.normal.woff2,
            format: 'woff2',
        },
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: 'Picsart-Fonts',
        fontStyle: 'italic',
        fontWeight: '500',
        src: {
            local: 'Gilroy-Medium',
            url: GilroyFontMediumUrls.italic.woff2,
            format: 'woff2',
        },
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: 'Picsart-Fonts',
        fontStyle: 'normal',
        fontWeight: '600',
        src: {
            local: 'Gilroy-SemiBold',
            url: GilroyFontSemiBoldUrls.normal.woff2,
            format: 'woff2',
        },
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: 'Picsart-Fonts',
        fontStyle: 'italic',
        fontWeight: '600',
        src: {
            local: 'Gilroy-SemiBold',
            url: GilroyFontSemiBoldUrls.italic.woff2,
            format: 'woff2',
        },
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: 'Picsart-Fonts',
        fontStyle: 'normal',
        fontWeight: 'bold',
        src: {
            local: 'Gilroy-Bold',
            url: GilroyFontBoldUrls.normal.woff2,
            format: 'woff2',
        },
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
    {
        fontFamily: 'Picsart-Fonts',
        fontStyle: 'italic',
        fontWeight: 'bold',
        src: {
            local: 'Gilroy-Bold',
            url: GilroyFontBoldUrls.italic.woff2,
            format: 'woff2',
        },
        fontDisplay: 'swap',
        unicodeRange: 'U+0020—007F',
    },
];
const FontWeights = {
    normal: 'normal',
    medium: '500',
    semibold: '600',
    bold: 'bold',
};

export { FontWeights, GilroyFonts };
